import { AgxLabel, BasicCampaignDetailModel } from '@urbanx/agx-ui-components';
import { CampaignsViewPageImageCard } from '../../../CampaignsViewPageImageCard/CampaignsViewPageImageCard';
import { useAppSelector } from 'hooks/useAppSelector';

interface GroupedCampaignProps {
  title?: string;
  campaigns: BasicCampaignDetailModel[];
  onCampaignClick: (campaignId: string) => void;
  unread?: boolean;
}

export const GroupedCampaigns = ({
  title,
  campaigns,
  onCampaignClick,
}: GroupedCampaignProps) => {
  const { selectedCampaignId } = useAppSelector(state => state.campaigns);

  if (campaigns.length === 0) return null;

  return (
    <>
      {title && <AgxLabel small>{title}</AgxLabel>}
      {campaigns.map((campaign, index) => (
        <CampaignsViewPageImageCard
          key={campaign.campaignId}
          onClick={() => onCampaignClick(campaign.campaignId)}
          campaign={campaign}
          index={index + 1}
          selected={selectedCampaignId === campaign.campaignId}
        />
      ))}
    </>
  );
};
